import React, { createContext, useState } from "react";
import IUser from "../models/User";

type Children = {
    children: React.ReactNode;
};
type UserContext = {
    user : IUser | undefined,
    setAuth : React.Dispatch<React.SetStateAction<IUser | undefined>>
}

export const AuthContext = createContext<UserContext>({} as UserContext);

export const AuthProvider = ({ children } : Children) => {
    const [user, setAuth] = useState<IUser>();

    return (
        <AuthContext.Provider value={{ user, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}